<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">INVOICE OTHER</h4>
              <button v-if="['finance','master_admin','admin'].includes(role)" class="float-right btn btn-primary shadow" 
              v-on:click="formInvoiceLainActive=!formInvoiceLainActive"
              >Tambah</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formInvoiceLainActive">
                <div class="row p-3 mx-2 bg-white shadow">
                  <div class="col-12 mb-3">
                    <!-- <h4 class="my-0 py-0">Form Invoice Lain</h4> -->
                    <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-inline">  <span style="color:red;">*</span></label> 
                    <smart-search :search-value="newInvoiceLain.clientlabel" 
                     init url="/api/master/seeker/pengguna" usedefault 
                     :default-value="newInvoiceLain.clientlabel" 
                     key-tag="first_name" :label-tag="['customer_id','legal_name']" 
                     v-on:update="(data)=>{newInvoiceLain.client_id=data.id}" 
                      @update-direct="(label)=>newInvoiceLain.clientlabel=label">
                    </smart-search> 
                    <!-- <smart-search 
                      init url="/api/master/seeker/vessel" 
                      :label-tag="['name']" 
                      key-tag="name" 
                      v-on:update="(data)=>smartSearchAddIdTransmitter(data)" 
                      :search-value="newhardwareidlabel" 
                      @update-direct="(label)=>newhardwareidlabel=label">
                    </smart-search> -->

                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-inline">NAMA KAPAL<span style="color:red;"></span></label> 
                    <smart-search 
                      init url="/api/master/seeker/vessel" 
                      :label-tag="['name']" 
                      key-tag="name" 
                      v-on:update="(data)=>smartSearchAddIdTransmitter(data)" 
                      :search-value="newhardwareidlabel" 
                      @update-direct="(label)=>newhardwareidlabel=label">
                    </smart-search>
                  </div>
                  <!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">NO INVOICE</label>
                    <input 
                      type="text"  
                      class="form-control w-100 rounded" 
                      v-model="newInvoiceLain.invoice_no"
                      placeholder="Masukkan nomor invoice"
                    />
                   
                  </div> -->
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">NO INVOICE</label>
                    <div class="input-group">
                    <!-- Input for invoiceId -->
                    <input type="text" class="form-control w-25 rounded" 
                      v-model="invoiceId" 
                      @input="updateInvoiceNumber" 
                      maxlength="6" 
                      style="background-color: #ffffff;" />
                    <!-- Format parts that cannot be changed -->
                    <input type="text" class="form-control w-75 rounded" 
                      :value="formattedInvoiceNumber" 
                      readonly style="background-color: #f0f0f0;"/>
                  </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">TANGGAL INVOICE</label>
                    <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date" v-model="newInvoiceLain.invoice_date" class="mb-2">{{newInvoiceLain.invoice_date}}</b-form-datepicker>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">TANGGAL JATUH TEMPO</label>
                    <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date" v-model="newInvoiceLain.due_date" class="mb-2">{{newInvoiceLain.due_date}}</b-form-datepicker>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">PPN-VAT</label>
                    <!-- <smart-select name="ppn" :options="ppnTypeOptions" v-on:update="updateNewPpn"></smart-select> -->
                    <!-- <smart-select name="ppn" 
                      :options="ppnTypeOptions" 
                      :value="newInvoiceLain.ppn" 
                      v-on:update="updateNewPpn">
                  </smart-select> -->
                  <smart-select name="ppn" 
                    :options="ppnTypeOptions" usedefault
                    :value="newInvoiceLain.ppn" 
                    v-on:update="updateNewPpn">
                  </smart-select>

                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">PIC</label>
                    <input 
                      type="text"  
                      class="form-control w-100 rounded" 
                      v-model="newInvoiceLain.pic"
                      placeholder="Masukkan nama pic" 
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">JABATAN</label>
                    <input 
                     type="text" 
                     class="form-control w-100 rounded" 
                     v-model="newInvoiceLain.division" 
                     placeholder="Masukkan nama Jabatan" 
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">KETERANGAN</label>
                    <textarea 
                      type="text"  
                      class="form-control w-100 rounded" 
                      v-model="newInvoiceLain.notes" 
                      placeholder="Masukkan Keterangan"
                     />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Account Bank</label>
                    <smart-search 
                    :search-value="newInvoiceLain.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="newInvoiceLain.label_bank" key-tag="nama" :label-tag="['no_rekening','nama']" v-on:update="(data)=>{newInvoiceLain.id_bank=data.id}"  @update-direct="(label)=>newInvoiceLain.label_bank=label"></smart-search>
                  </div>
                  
                  <div class="col-12 mt-2">
                    <br>
                    <b>List item:</b>
                    <hr>
                    <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in newInvoiceLain.items" v-bind:key="'newitem'+item.id">
                      <div class="col-12">
                        <button class="float-right btn btn-sm btn-danger bg-white" @click="newInvoiceLain.items.splice(index, 1);">hapus</button>
                      </div>
                      <div class="col-12 col-md-4">
                        <label class="d-block">Item</label>
                        <!-- <smart-search init url="/api/master/seeker/item-lain" :label-tag="['item_name']" key-tag="item_name" v-on:update="(data)=>{item.item_name=data.item_name;item.item_id=data.id;item.price=data.price;calculateAmount()}" :search-value="item.item_name" @update-direct="(label)=>item.item_name=label"></smart-search> -->
                        <smart-search 
                        init 
                        url="/api/master/seeker/item-lain" 
                        :label-tag="['item_name', 'price']" 
                        key-tag="item_name" 
                        v-on:update="(data) => {
                          item.item_name = data.item_name;
                          item.item_id = data.id;
                          item.price = data.price; 
                          calculateAmount();
                        }" 
                        :formatter="(data) => `${data.item_name} - ${data.price} IDR`" 
                        :search-value="item.item_name" 
                        @update-direct="(label) => item.item_name = label">
                      </smart-search>
                      </div>
                      <div class="col-12 col-md-2">
                        <label class="d-block">Quantity</label>
                        <input type="number" class="form-control w-100 rounded" v-model="item.qty" @input="calculateAmount()" />
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Harga</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price | numeral('0,0') }}</div>
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Total</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price * item.qty | numeral('0,0') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <button class="float-right btn btn-secondary" @click="newInvoiceLain.items.push({item_id:-1,qty:1,price:0})">Tambah</button>
                  </div>
                  
                  <div class="col-12 mt-2">
                    <br><br>
                    <hr>
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Harga</label>
                      <div type="text"  class="form-control col-12 col-md-6  text-right w-100 rounded">
                        {{ newInvoiceLain.subtotal | numeral('0,0') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Diskon</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         -{{ newInvoiceLain.discount | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Sub total</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         {{ newInvoiceLain.subtotal | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Total PPN</label>
                      <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                         {{ newInvoiceLain.totalPPN | numeral('0,0') }}
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-2">
                    <div class="row">
                      <label class="d-block col-12 col-md-6 text-right">Total</label>
                      <div type="text"  class="form-control w-100 col-12 text-right col-md-6 rounded">
                         <b>{{ newInvoiceLain.total | numeral('0,0') }}</b>
                      </div>
                    </div>  
                  </div>
                  <div class="col-12 mt-3">
                      <div class="w-100 align-items-center justify-content-start" v-if="newInvoiceLainSaved">
                          <div class="alert alert-success" role="alert">
                              Berhasil Menyimpan Invoice Baru.
                          </div>
                      </div>
                  </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewInvoiceLain">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal Menyimpan Invoice Lain Baru.</p>
                                </div>
                                <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewInvoiceLain">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="savenewInvoiceLain">SIMPAN</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable :currentIdx="currentPage" :lang="dicts.lang" :datas="invoiceitems"
                      :structure="tableStructure" :init="loadData" 
                      :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
                      use-filter use-seeker seeker-url="/api/pemesanan/seeker/invoice-lain"
                      use-xml xml-url="/api/xml/invoice-lain"
                     @refetch="(row)=>{rowLimit=row;getInvoiceLains()}"
                     @searching="(val)=>!val.status?getInvoiceLains():setInvoiceLains(val)">
                <template #customcell={obj,index}>
                    <td>{{ index+ 1 }}</td>
                    <td>{{ obj.invoice_no}}</td>
                    <td>{{ obj.client.customer_id}}</td>
                    <td>{{ obj.client != null? obj.client.first_name:'-'}}</td>
                    <td>{{ getVesselName(obj.vessel_id) }}</td>
                    <td>{{ obj.client ? obj.client.npwp : '-' }}</td>
                    <td>{{ obj.invoice_date | timeformat}}</td>
                    <td>{{ obj.due_date | timeformat}}</td>
                    <td>{{ obj.notes}}</td>
                    <!-- <td>
                      <b-button  v-b-modal.modal-sap class="btn btn-success" :href="'http://192.168.70.138:8000/api/invoice/airtime-sap/'+obj.id"><b>SAP</b></b-button>
                    </td> -->
                    <td>
                        <b-button class="btn btn-warning mr-2 mb-1" :href="'http://192.168.70.138:8000/api/invoice/lain/'+obj.id+'?qr=yes'"><b-icon icon="printer"></b-icon></b-button>
                        <b-button class="btn btn-secondary mr-2 mb-1" :href="'http://192.168.70.138:8000/api/invoice/lain/'+obj.id+'?proforma=yes&qr=yes'"><b-icon icon="printer"></b-icon></b-button>
                        <b-button v-b-modal.modal-detail-invoice-lain class="btn btn-primary mr-2 mb-1" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                        <b-button v-b-modal.modal-edit-invoice class="btn btn-info mr-2 mb-1" v-if="['master_admin','admin'].includes(role)"><b-icon icon="pencil-square"></b-icon></b-button>
                        <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"  class="btn btn-danger mr-2 mb-1" v-if="['master_admin','admin'].includes(role)"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
            </datatable>
          </div>
          <b-modal id="modal-edit-invoice" title="Edit data" scrollable no-close-on-backdrop size="lg"
                 @hide="editModalClose" v-if="invoiceitems.length>0">
                 <div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-inline">Pelanggan<span style="color:red;">*</span></label> 
                      <smart-search :search-value="newInvoiceLain.clientlabel" init url="/api/master/seeker/pengguna" usedefault :default-value="invoiceitems[selectedIdforEdit].client.first_name" key-tag="first_name" :label-tag="['customer_id','legal_name']" v-on:update="(data)=>{newInvoiceLain.client_id=data.id}"  @update-direct="(label)=>newInvoiceLain.clientlabel=label"></smart-search>
                    </div>
                    <!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Pelanggan</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="newInvoiceLain.client_name"/>
                    </div> -->
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Nomor Invoice</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Tanggal invoice</label>
                      <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-invoice-date" v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">{{newInvoiceLain.invoice_date}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Tanggal invoice jatuh tempo</label>
                      <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date" v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">{{newInvoiceLain.due_date}}</b-form-datepicker>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">PPN</label>
                      <smart-select name="ppn" :options="ppnTypeOptions" v-on:update="invoiceitems[selectedIdforEdit].ppn"></smart-select>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">PIC</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].pic" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Jabatan</label>
                      <input type="text" class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].division" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Keterangan</label>
                      <textarea type="text"  class="form-control w-100 rounded" v-model="invoiceitems[selectedIdforEdit].notes" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                      <label class="d-block">Account Bank</label>
                      <smart-search 
                      :search-value="newInvoiceLain.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="invoiceitems[selectedIdforEdit].bank == null ?'' : invoiceitems[selectedIdforEdit].bank.nama" key-tag="nama" v-on:update="(data)=>{invoiceitems[selectedIdforEdit].id_bank=data.id}"  @update-direct="(label)=>newInvoiceLain.label_bank=label"></smart-search>
                    </div>
                    <div class="col-12 mt-2">
                      <br>
                      <b>List item:</b>
                      <hr>
                      <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in invoiceitems[selectedIdforEdit].metadata" v-bind:key="'newitem'+item.id">
                        <div class="col-12">
                          <button class="float-right btn btn-sm btn-danger bg-white" @click="newInvoiceLain.items.splice(index, 1);">hapus</button>
                        </div>
                        <div class="col-12 col-md-4">
                          <label class="d-block">Item</label>
                          <smart-search 
                            usedefault :default-value="item.item_name" 
                            init url="/api/master/seeker/item-lain" :label-tag="['item_name']" key-tag="item_name" v-on:update="(data)=>{item.item_name=data.item_name;item.item_id=data.id;item.price=data.price;calculateUpdateAmount()}" :search-value="item.item_name" @update-direct="(label)=>item.item_name=label"></smart-search>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="d-block">Quantity</label>
                          <input type="number" class="form-control w-100 rounded" v-model="item.qty" @input="calculateUpdateAmount()" />
                        </div>
                        <div class="col-12 col-md-3">
                          <label class="d-block">Harga</label>
                        <div type="text" class="form-control w-100 rounded" >{{ item.price | numeral('0,0') }}</div>
                        </div>
                        <div class="col-12 col-md-3">
                          <label class="d-block">Total</label>
                        <div type="text" class="form-control w-100 rounded" >{{ item.price * item.qty | numeral('0,0') }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-2">
                    <br>
                    <b>List item:</b>
                    <hr>
                    <div class="row py-2" style="background:#f0f0f0" v-for="(item,index) in newInvoiceLain.items" v-bind:key="'newitem'+item.id">
                      <div class="col-12">
                        <button class="float-right btn btn-sm btn-danger bg-white" @click="newInvoiceLain.items.splice(index, 1);">hapus</button>
                      </div>
                      <div class="col-12 col-md-4">
                        <label class="d-block">Item</label>
                        <smart-search init url="/api/master/seeker/item-lain" :label-tag="['item_name']" key-tag="item_name" v-on:update="(data)=>{item.item_name=data.item_name;item.item_id=data.id;item.price=data.price;calculateAmount()}" :search-value="item.item_name" @update-direct="(label)=>item.item_name=label"></smart-search>
                      </div>
                      <div class="col-12 col-md-2">
                        <label class="d-block">Quantity</label>
                        <input type="number" class="form-control w-100 rounded" v-model="item.qty" @input="calculateAmount()" />
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Harga</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price | numeral('0,0') }}</div>
                      </div>
                      <div class="col-12 col-md-3">
                        <label class="d-block">Total</label>
                      <div type="text" class="form-control w-100 rounded" >{{ item.price * item.qty | numeral('0,0') }}</div>
                      </div>
                    </div>
                  </div>
                    <div class="col-12 mt-3">
                      <button class="float-right btn btn-secondary" @click="newInvoiceLain.items.push({item_id:-1,qty:1,price:0})">tambah</button>
                    </div>
                    
                    <div class="col-12 mt-2">
                      <br><br>
                      <hr>
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Harga</label>
                        <div type="text"  class="form-control col-12 col-md-6  text-right w-100 rounded">
                          {{ invoiceitems[selectedIdforEdit].subtotal | numeral('0,0') }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Diskon</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                           -{{ invoiceitems[selectedIdforEdit].discount | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Sub total</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                           {{ invoiceitems[selectedIdforEdit].subtotal | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Total PPN</label>
                        <div type="text"  class="col-12 col-md-6 form-control text-right w-100 rounded">
                          //  {{ invoiceitems[selectedIdforEdit].subtotal/10 | numeral('0,0') }}
                           {{ invoiceitems[selectedIdforEdit].subtotal | numeral('0,0') }}
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-2">
                      <div class="row">
                        <label class="d-block col-12 col-md-6 text-right">Total</label>
                        <div type="text"  class="form-control w-100 col-12 text-right col-md-6 rounded">
                           <b>{{ invoiceitems[selectedIdforEdit].total | numeral('0,0') }}</b>
                        </div>
                      </div>  
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newInvoiceLainSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil Menyimpan Invoice Lain Baru.
                            </div>
                        </div>
                    </div>
                      
                      <div class="col-12 mt-3">
                          <div class="w-100 align-items-center justify-content-start" v-if="errorNewInvoiceLain">
                              <div class="alert alert-danger" role="alert">
                                  <div class="my-0">
                                      <p  class="d-block mt-1">Gagal Menyimpan Invoice Lain Baru.</p>
                                  </div>
                                  <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                                      <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-12 mt-3">
                          <div class="d-flex align-items-center justify-content-start" v-if="savingNewInvoiceLain">
                              <div class="spinner-border" role="status" aria-hidden="true"></div>
                              <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                          </div>
                      </div>
                  </div>
              <!-- <div class="row" v-if="invoiceitems[selectedIdforEdit]!=undefined">
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.so[dicts.lang] }}</label>
                  <div class="form-control w-100 rounded">
                    {{
                      invoiceitems[selectedIdforEdit].sales_order != undefined && invoiceitems[selectedIdforEdit].sales_order != null ? invoiceitems[selectedIdforEdit].sales_order.order_number : "-"
                    }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.no_invoice[dicts.lang] }}</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].invoice_no"/>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.invoice_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-invoice-date"
                                     v-model="invoiceitems[selectedIdforEdit].invoice_date" class="mb-2">
                    {{ invoiceitems[selectedIdforEdit].invoice_date }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.invoice_due_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-due-date"
                                     v-model="invoiceitems[selectedIdforEdit].due_date" class="mb-2">
                    {{ invoiceitems[selectedIdforEdit].due_date }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.start_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-update-start-date-activation"
                                     @input="(e)=>{invoiceitems[selectedIdforEdit].active_date_setup=e}"
                                     :value="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active"
                                     class="mb-2"></b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.due_date[dicts.lang] }}</label>
                  <b-form-datepicker today-button reset-button close-button locale="id"
                                     :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}"
                                     id="datepicker-update-end-date-activation"
                                     @input="(e)=>{invoiceitems[selectedIdforEdit].due_date_setup=e}"
                                     v-model="invoiceitems[selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due"
                                     class="mb-2">{{ invoiceitems[selectedIdforEdit].due_date_setup }}
                  </b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.hardware_price[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/hardware-price" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].hardware_price.name_hardware_price"
                                @clear="smartSearchUpdateHardwarePrice(null)" key-tag="name_hardware_price"
                                v-on:update="(data)=>smartSearchUpdateHardwarePrice(data)"></smart-search>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.airtime_price[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/airtime-price" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].name_airtime_price"
                                @clear="smartSearchUpdateAirtimePrice(null)" key-tag="name_airtime_price"
                                v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)"></smart-search>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.discount[dicts.lang] }}</label>
                  <smart-search init url="/api/master/seeker/discount" usedefault
                                :default-value="invoiceitems[selectedIdforEdit].discount_detail!=undefined&&invoiceitems[selectedIdforEdit].discount_detail.discount"
                                key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
                                v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
                </div>

                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Total {{ dicts.discount[dicts.lang] }}</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].discount | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Sub Total</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].subtotal | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.ppn[dicts.lang] }}</label>
                  <smart-select name="ppn" :options="ppnTypeOptions"
                                v-on:update="(value)=>{invoiceitems[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}"></smart-select>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">Total</label>
                  <div class="form-control w-100 rounded">
                    {{ invoiceitems[selectedIdforEdit].total | numeral("0,0") }}
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">PIC</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].cp"/>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <label class="d-block">{{ dicts.position[dicts.lang] }}</label>
                  <input type="text" class="form-control w-100 rounded"
                         v-model="invoiceitems[selectedIdforEdit].department"/>
                </div>

                <div class="col-12 mt-3">
                  <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
                    <div class="alert alert-success" role="alert">
                      Berhasil Update Data Invoice Perangkat.
                    </div>
                  </div>
                </div>
              </div> -->
          <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
              <hr>
              <div class="col-12 mt-3">
                <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                  <div class="alert alert-danger" role="alert">
                    <div class="my-0">
                      <p class="d-block mt-1 text-left">Gagal update Invoice Perangkat.</p>
                    </div>
                    <div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
                      <p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="d-flex align-items-center justify-content-start" v-if="updating">
                  <div class="spinner-border" role="status" aria-hidden="true"></div>
                  <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                </div>
                <button class="btn btn-info float-right" type="button" v-on:click="updateInvoiceItem">
                  {{ dicts.submit[dicts.lang] }}
                </button>
                <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
                  {{ dicts.close[dicts.lang] }}
                </b-button>
              </div>
            </div>
          </template>
        </b-modal>

        <b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail Invoice" id="modal-detail-invoice-lain"
                 scrollable no-close-on-backdrop @hide="detailModalClose">
          <b-container fluid v-if="!loadData&&invoiceitems.length>0">
            <b-row class="pt-1" v-if="invoiceitems[selectedDetail]!=undefined">
              <b-col cols="12">
                <table v-if="invoiceitems.length>0" rules="rows" class="table w-100"
                       style="overflow-x:auto;">
                  <tbody>
                  <tr>
                    <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
                        colspan="2" scope="row">Detail Invoice
                    </th>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.no_invoice[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].invoice_no }}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.invoice_date[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].invoice_date }}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.due_date[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].due_date }}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.client[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].client != null ? invoiceitems[selectedDetail].client.first_name : '' }}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.pic[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].pic}}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.ppn[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].ppn}}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.notes[dicts.lang] }}</th>
                    <td class="">{{ invoiceitems[selectedDetail].notes}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <table rules="rows" class="table w-100"
                             style="overflow-x:auto;">
                        <tbody>
                        <tr>
                          <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
                              colspan="4" scope="row">List Item
                          </th>
                        </tr>
                        <tr>
                          <th class="">{{dicts.item_name[dicts.lang]}}</th>
                          <td class="">{{dicts.qty[dicts.lang]}}</td>
                          <td class="">{{dicts.price[dicts.lang]}}</td>
                          <td class="">{{dicts.total[dicts.lang]}}</td>
                        </tr>
                        <tr v-for="dataItem in invoiceitems[selectedDetail].metadata" :key="index">
                          <th class="">{{ dataItem.item.item_name }}</th>
                          <td class="">{{ dataItem.qty }}</td>
                          <td class="">{{ Number(dataItem.price).toLocaleString() }}</td>
                          <td class="">{{ Number(dataItem.price*dataItem.qty).toLocaleString() }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.discount[dicts.lang] }}</th>
                    <td class="">{{ Number(invoiceitems[selectedDetail].discount).toLocaleString()}}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.subtotal[dicts.lang] }}</th>
                    <td class="">{{ Number(invoiceitems[selectedDetail].subtotal).toLocaleString()}}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.total_ppn[dicts.lang] }}</th>
                    <td class="">{{ Number(invoiceitems[selectedDetail].total - invoiceitems[selectedDetail].subtotal - invoiceitems[selectedDetail].discount).toLocaleString()}}</td>
                  </tr>
                  <tr>
                    <th class="" scope="row">{{ dicts.total[dicts.lang] }}</th>
                    <td class="">{{ Number(invoiceitems[selectedDetail].total).toLocaleString()}}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-container>
          <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
              <hr>
              <b-button class="btn btn-secondary"
                        @click="(!deleteUserState)?$bvModal.hide('modal-detail-invoice-lain'):''">
                {{ dicts.close[dicts.lang] }}
              </b-button>
            </div>
          </template>
        </b-modal>
        
      </div>
    </div>
    


    <modal-delete url="/api/pemesanan/invoice-lain/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
      Yakin mau menghapus data dengan detail berikut:<br>
      <ul>
        <li>Nomor Invoice: {{ itemToDelete.invoice_no }}</li>
      </ul>
    </modal-delete>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import SmartSearch from '../../components/SmartSearch.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'smart-search':SmartSearch,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                base_ppn:12,
                currentPage: 1,
                perPage: null,
                rowLimit: 10,
                nextUrl: null,
                prevUrl: null,
                role:'',
                selectedDetail:0,
                newairtimediskonlabel:'',
                newairtimepricelabel:'',
                selectedHardwareSetup:{},
                newhardwareidlabel:'',
                isMobile:false,
                itemToDelete:{},
                invoiceitems:[],
                searchValue:'',
                loadData:true,
                savingNewInvoiceLain:false,
                errorNewInvoiceLain:false,
                errorInvoiceItemList:[],
                existingClientResult:[],
                newInvoiceLainSaved:false,
                selectedTab:0,
                newHardwarePrice:0,
                newLainPrice:0,
                updateLainPrice:0,
                newDiscount:0,
                updateDiscount:0,
                selectedIdforEdit:0,
                updateSaved:false,
                errorUpdate:false,
                updating:false,
                deleteId:0,
                newBanklabel:'',
                invoiceId:"",
                prefix: '0088/INV/MSP/X/2024', // Prefix untuk nomor invoice
                // deleteTargetId:0,
                vessels: [],
                newInvoiceLain:{
                  invoice_no: '',
                  items:[
                    {item_id:-1,item_name:'',qty:1,price:0}
                  ],
                  clientlabel:'',
                  client_id:0,
                  // client_name:'',
                  invoice_no:'',
                  invoice_date:new Date(),
                  due_date:new Date(),
                  discount:0,
                  discountId :0,
                  id_bank:'',
                  label_bank:'',
                  subtotal :0,
                  total :0,
                  totalPPN :0,
                  ppn :0,
                  ppn_number: 0,
                  notes :'',
                  pic :'',
                  division :''
                },
                formInvoiceLainActive:false,
                tableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'NO',key:null},
                    {
                      label: {
                        id: "NOMER INVOICE",
                        en: "NOMER INVOICE"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "CID",
                        en: "CID"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "NAMA PELANGGAN",
                        en: "CUSTOMER NAME"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "NAMA KAPAL",
                        en: "NAME OF THE SHIP"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "NPWP",
                        en: "NPWP"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "TANGGAL INVOICE",
                        en: "INVOICE DATE"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "TANGGAL AKHIR",
                        en: "END DATE"
                      },
                      key: null
                    },
                    {
                      label: {
                        id: "KETERANGAN",
                        en: "INFOMATION"
                      },
                      key: null
                    },
                    // {label:'Pemilik',key:null},
                    // {label:'NPWP',key:null},
                    // {label:'Tanggal',key:null},
                    // {label:'SAP',key:null},
                    {label:'TINDAKAN',key:null},
                ],
                dicts: {
                  lang: "id",
                  no_invoice: {
                    id: "Nomor invoice",
                    en: "Invoice number"
                  },
                  invoice_date: {
                    id: "Tanggal Invoice",
                    en: "Invoice Date"
                  },
                  due_date: {
                    id: "Jatuh Tempo",
                    en: "Due Date"
                  },
                  client: {
                    id: "Nama Client",
                    en: "Client Name"
                  },
                  ppn: {
                    id: "PPN",
                    en: "PPN"
                  },
                  pic: {
                    id: "PIC",
                    en: "PIC"
                  },
                  division: {
                    id: "Jabatan",
                    en: "Devision"
                  },
                  item_name: {
                    id: "Nama Item",
                    en: "Item Name"
                  },
                  qty: {
                    id: "Quantity",
                    en: "Quantity"
                  },
                  price: {
                    id: "Harga",
                    en: "Price"
                  },
                  total: {
                    id: "Total",
                    en: "Total"
                  },
                  
                  total_ppn: {
                    id: "Total PPN",
                    en: "Total PPN"
                  },
                  discount: {
                    id: "Discount",
                    en: "Discount"
                  },
                  subtotal: {
                    id: "SubTotal",
                    en: "SubTotal"
                  },
                  notes: {
                    id: "Keterangan",
                    en: "Notes"
                  },
                  submit: {
                    id: "Simpan",
                    en: "Submit"
                  },
                  close: {
                    id: "Tutup",
                    en: "Close"
                  },
                },
                proformaTypeOptions:[
                  {label:'Tidak',value:'no'},
                  {label:'Ya',value:'yes'},
                ],
                qrCodeTypeOptions:[
                  {label:'Tidak',value:'no'},
                  {label:'Ya',value:'yes'},
                ],
                ppnTypeOptions: [
                  {label: "Tidak Ada", value: 0},
                  { label: '11', value: 11 },
                  { label: '12', value: 12 },
                  
                ],
               
            }
        },
        computed: {
          
          invoiceNo() {
            const monthNames = [
            "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"
            ];
            const now = new Date();
            const month = monthNames[now.getMonth()]; // Mendapatkan bulan dalam format Romawi
            const year = now.getFullYear(); // Mendapatkan tahun
            return `${this.prefix}/${month}/${year}`;
          },
          formattedInvoiceNumber() {
              const currentDate = new Date();
              const year = currentDate.getFullYear(); 
              const monthIndex = currentDate.getMonth(); 
              const romanMonths = [
                "I", "II", "III", "IV", "V", "VI", 
                "VII", "VIII", "IX", "X", "XI", "XII"
              ];
              const romanMonth = romanMonths[monthIndex];

              // Format nomor invoice
              return `${this.invoiceId}/INV-OT-MSP/${romanMonth}/${year}`;
            },
        },
        watch: {
          invoiceNo(newValue) {
            this.newInvoiceLain.invoice_no = newValue;
            
          }
        },
        created(){
            this.role=localStorage.getItem('role')
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            this.getInvoiceLains();
            this.getNoINvoice();
            this.getSetPpn();
            this.fetchVessels();
        },
        methods:{
            
            getNoINvoice(){
              axios.get(this.$baseUrl + "/api/pemesanan/no_invoice/invoice-lain", {
                "headers": {
                  "Authorization": "Bearer " + localStorage.getItem("accessToken")
                }
              }).then((result) => {
                console.log(result);
                this.newInvoiceLain.invoice_no = result.data.create;
              }).catch((err) => {
                //check if token fail
              });
            },
            editPreparation(index) {
              console.log("index for edit: " + index);
              this.selectedIdforEdit = index;
              console.log(this.invoiceitems[index]);
              this.cache.editItem = Object.assign({}, this.invoiceitems[index]);
              console.log(this.cache.editItem);
              console.log("edit journey start here");
            },
            editModalClose(mdl) {
              if (false) {
                console.log(this.cache.editItem);
                this.$set(this.invoiceitems, this.selectedIdforEdit, Object.assign({}, this.cache.editItem));
                this.cache.editItem = Object.assign({}, {});
                console.log(this.invoiceitems[this.selectedIdforEdit]);
                this.$forceUpdate();
                if (this.updating) {
                  console.log("updating");
                  mdl.preventDefault();
                } else {
                  console.log("closing");
                }
              }
            },
            changePage(isNext) {
              var url = (isNext ? this.nextUrl : this.prevUrl);
              let params = (new URL(url)).searchParams;
              const myParams = params.get("page");
              this.currentPage = myParams;
              var newUrl = this.$baseUrl + "/api/pemesanan/invoice-lain?limit=" + this.rowLimit + "&page=" + myParams;
              this.getInvoiceLains(newUrl);
            },
            resetNewInvoice(){
              this.newInvoiceLain.invoice_no=''
              this.newInvoiceLain.invoice_date=''
              this.newInvoiceLain.due_date=''
              this.newInvoiceLain.discount=0
              this.newInvoiceLain.subtotal =0
              this.newInvoiceLain.total =0
              this.newInvoiceLain.totalPPN =0
              this.newInvoiceLain.id_bank = ''
              this.newInvoiceLain.ppn ='yes'
              this.newInvoiceLain.ppn_number = "0";
              this.newInvoiceLain.notes =''
              this.newInvoiceLain.pic ='dewi'
              this.newInvoiceLain.division ='manager finance'
              this.newInvoiceLain.invoice_proforma =''
              this.newInvoiceLain.invoice_date_proforma =''
              this.newInvoiceLain.due_date_proforma =''
              this.newInvoiceLain.status ='paid'
              this.newhardwareidlabel=''
              this.selectedHardwareSetup = {}
              this.newairtimepricelabel=''
              this.newairtimediskonlabel=''
            },
            updateInvoiceItem() {
              this.updating = true;
              this.errorUpdate = false;
              axios.put(
                this.$baseUrl + "/api/pemesanan/invoice-lain/" + this.invoiceitems[this.selectedIdforEdit].id,
                this.invoiceitems[this.selectedIdforEdit],
                {
                  headers: {
                    "Authorization": "Bearer " + localStorage.getItem("accessToken")
                  }
                }
              ).then((result) => {
                if (result.status = 200) {
                  this.cache.editItem = this.invoiceitems[this.selectedIdforEdit];
                  if (this.invoiceitems[this.selectedIdforEdit].active_date_setup != undefined) {
                    this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_active = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
                  }
                  if (this.invoiceitems[this.selectedIdforEdit].due_date_setup != undefined) {
                    this.invoiceitems[this.selectedIdforEdit].invoice_metadata[0].order_metadata.hardware_setup.date_due = this.invoiceitems[this.selectedIdforEdit].active_date_setup;
                  }
                  this.updating = false;
                  this.updateSaved = true;
                  setTimeout(() => {
                    this.updateSaved = false;
                    this.$bvModal.hide("modal-edit-invoice");
                  }, 1000);
                }
                console.log(result);
              }).catch((err) => {
                //check if token fail
                if (err.response && err.response.status == 401) {
                  localStorage.removeItem("accessToken");
                  this.$router.push("/login");
                }
                this.updating = false;
                this.errorUpdate = true;
                setTimeout(() => {
                  this.errorUpdate = false;
                }, 1000);
                console.log(err);
              });
            },
            setInvoiceLains(result){
              this.prevUrl = result.data.prev_page_url;
              this.nextUrl = result.data.next_page_url;
              this.currentPage = result.data.current_page;
              this.perPage = parseInt(result.data.per_page);
              this.invoiceitems = result.data.data;
              this.loadData=false
            },
            getInvoiceLains(url=(this.$baseUrl+'/api/pemesanan/invoice-lain?limit=' + this.rowLimit)){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    this.prevUrl = result.data.prev_page_url;
                    this.nextUrl = result.data.next_page_url;
                    this.currentPage = result.data.current_page;
                    this.perPage = parseInt(result.data.per_page);
                    this.invoiceitems = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            openXml()
            {
              var url = this.$baseUrl+'/api/xml/invoice-lain';
              window.open(url, "_blank");
            },
            deleteResult(deleted){
              console.log(deleted)
              if(deleted){
                this.getInvoiceLains();
              }
            },
            detailModalClose(mdl) {
              if (this.updating) {
                console.log("updating");
                mdl.preventDefault();
              } else {
                console.log("closing");
                mdl.hide("modal-detail-invoice-lain");
              }
            },
            calculateAmount(){
             
              this.newInvoiceLain.subtotal = 0;

              // Hitung subtotal berdasarkan qty dan harga
              this.newInvoiceLain.items.forEach((data) => {
                this.newInvoiceLain.subtotal += (data.qty * data.price);
              });

              // Kurangi diskon dari subtotal
              this.newInvoiceLain.subtotal -= this.newInvoiceLain.discount;

              // Reset totalPPN
              this.newInvoiceLain.totalPPN = 0;

              // Hitung totalPPN berdasarkan nilai PPN yang dipilih
              if (this.newInvoiceLain.ppn && !isNaN(this.newInvoiceLain.ppn)) {
                this.newInvoiceLain.totalPPN = this.newInvoiceLain.subtotal * (parseFloat(this.newInvoiceLain.ppn) / 100);
              }

              // Hitung total akhir
              this.newInvoiceLain.total = this.newInvoiceLain.subtotal + this.newInvoiceLain.totalPPN;

              

            },
            calculateUpdateAmount(){
                // if(this.invoiceitems[this.selectedIdforEdit].airtime_price>0){
                //   if(this.updateDiscount.discount_type!=undefined){
                //     if(this.updateDiscount.discount_type=='nominal'){
                //       this.invoiceitems[this.selectedIdforEdit].discount=data.price
                //     }else{
                //       if(this.invoiceitems[this.selectedIdforEdit].airtime_price>0){
                //         this.invoiceitems[this.selectedIdforEdit].discount = this.invoiceitems[this.selectedIdforEdit].airtime_price * this.updateDiscount.price / 100
                //       }
                //     }
                //   }
                //     this.invoiceitems[this.selectedIdforEdit].subtotal = parseInt(this.invoiceitems[this.selectedIdforEdit].airtime_price) - parseInt(this.invoiceitems[this.selectedIdforEdit].discount);
                //     var ppn = 0
                //     if(this.invoiceitems[this.selectedIdforEdit].ppn=="yes"){
                //       ppn =  this.invoiceitems[this.selectedIdforEdit].subtotal * (this.base_ppn/100)

                //     }
                //       this.invoiceitems[this.selectedIdforEdit].total = this.invoiceitems[this.selectedIdforEdit].subtotal +ppn;
                    
                // }else{
                //     this.invoiceitems[this.selectedIdforEdit].subtotal=0
                // }
                const selectedItem = this.invoiceitems[this.selectedIdforEdit];
                if (!selectedItem) return;

                // Reset nilai default
                selectedItem.discount = 0;
                selectedItem.subtotal = 0;
                selectedItem.total = 0;

                selectedItem.ppn_number = selectedItem.ppn;

                if (selectedItem.airtime_price > 0) {
                
                if (this.updateDiscount && this.updateDiscount.discount_type) {
                  if (this.updateDiscount.discount_type === "nominal") {
                  selectedItem.discount = this.updateDiscount.price || 0;
                  } else if (this.updateDiscount.discount_type === "percentage") {
                  selectedItem.discount =
                    (selectedItem.airtime_price * this.updateDiscount.price) / 100;
                  }
                }
                selectedItem.subtotal = selectedItem.airtime_price - selectedItem.discount;

                if (selectedItem.ppn > 0) {
                  
                  const calculatedPPN = (selectedItem.subtotal * selectedItem.ppn) / 100;
                  
                  selectedItem.total = selectedItem.subtotal + calculatedPPN;
                } else {
                  
                  selectedItem.total = selectedItem.subtotal;
                }
                }
            },
            updateNewIiProforma(data){
                this.newInvoiceLain.proforma=data
            },
            updateNewQrCode(data){
                this.newInvoiceLain.qrCode=data
            },
            updateNewPpn(data){
                this.newInvoiceLain.ppn=data
                this.calculateAmount()
            },
            updateNewIiLain(data){
                this.newInvoiceLain.airtime=data
            },
            savenewInvoiceLain(){
                this.savingNewInvoiceLain=true
                this.errorNewInvoiceLain=false
                console.log(this.newInvoiceLain)
                if(
                  this.newInvoiceLain.client_id !='' && 
                  this.newInvoiceLain.invoiceItemMetadataId !='' && 
                  this.newInvoiceLain.startPeriod !='' && 
                  this.newInvoiceLain.total !='' &&
                  this.newInvoiceLain.subtotal !=''
                  ){
                    axios.post(this.$baseUrl+'/api/pemesanan/invoice-lain',this.newInvoiceLain,
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        console.log(result)
                        this.savingNewInvoiceLain=false
                        this.newInvoiceLainSaved=true
                        this.resetNewInvoice()
                        this.getInvoiceLains()
                        this.getNoINvoice()
                        setTimeout(() => {
                            this.formInvoiceLainActive=false
                            this.newInvoiceLainSaved=false
                        }, 1000);
                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                          localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.clear()
                        console.log(err.response)
                        this.savingNewInvoiceLain=false
                        this.errorNewInvoiceLain=true
                    })
                    }else{
                      console.log('data invalid')
                      this.errorNewInvoiceLain=true
                    }
            },
            // updateInvoiceLain(){
            //     this.updating=true
            //     this.errorUpdate=false
            //     axios.put(this.$baseUrl+'/api/pemesanan/invoice-airtime/'+this.invoiceitems[this.selectedIdforEdit].id,this.invoiceitems[this.selectedIdforEdit],
            //     {
            //       headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
            //     }).then((result)=>{
            //         if(result.status=200){
            //             this.updating=false
            //             this.updateSaved=true
            //             setTimeout(() => {
            //                 this.updateSaved=false
            //                 this.$bvModal.hide('modal-edit-invoice')
            //             }, 1000);
            //         }
            //         console.log(result)
            //     }).catch((err)=>{
            //         //check if token fail
            //         if(err.response && err.response.status==401){
            //           localStorage.removeItem('accessToken')
            //         this.$router.push('/login')
            //         }
            //         this.updating=false
            //         this.errorUpdate=true
            //         console.log(err.response)
            //     })
            // },
            newUsernameChange(){
                this.newInvoiceLain.password = this.newInvoiceLain.username.toUpperCase();
            },
            deleteItem(item){
                console.log('button delete untuk user id: '+item.id)
            },
            updateUserRoleValue(newValue){
                this.newInvoiceLain.role=newValue
            },
            setNewClientId(newId){
                this.newInvoiceLain.clientId = newId;
                console.log(this.newInvoiceLain.clientId)
            },
            SmartSearchItem(data){
                this.newInvoiceLain.invoiceItemMetadataId=data.order_metadata.invoice_item_metadata.id
                this.selectedHardwareSetup=data
            },
            smartSearchBank(data)
            {
              if (data == null) {
                this.newInvoiceLain.id_bank = "";
                this.$forceUpdate();
                return;
              }
              this.newInvoiceLain.id_bank = data.id;
              this.$forceUpdate();
            },
            smartSearchHardwarePrice(data){
                // this.newInvoiceLain.price_hardware=data.id
                this.newHardwarePrice = data.price
                this.calculateAmount()
            },
            smartSearchLainPrice(data){
                this.newInvoiceLain.itemPrice=data.price
                this.newInvoiceLain.airtimeMonthDuration=data.month_duration
                this.newInvoiceLain.itemPriceId=data.id
                this.newLainPrice = data
                this.$forceUpdate()
                this.calculateAmount()
            },
            smartSearchUpdateLainPrice(data){
                this.invoiceitems[this.selectedIdforEdit].airtime_price=data.price
                this.invoiceitems[this.selectedIdforEdit].airtime_month_duration=data.month_duration
                this.invoiceitems[this.selectedIdforEdit].airtime_price_id=data.id
                this.updateLainPrice = data
                this.$forceUpdate()
                this.calculateUpdateAmount()
            },
            smartSearchDiscount(data){
              if(data==null){
                this.newInvoiceLain.discount=0
                this.newInvoiceLain.discountId=0
                this.newDiscount = {}
                this.$forceUpdate()
                return
              }
              
              this.newInvoiceLain.discountId=data.id
              this.newInvoiceLain.discount=data.price
              this.newDiscount = data
              this.$forceUpdate()
              this.calculateAmount()
            },
            smartSearchUpdateDiscount(data){
              if(data==null){
                this.invoiceitems[this.selectedIdforEdit].discount=0
                this.invoiceitems[this.selectedIdforEdit].discount_id=''
                this.updateDiscount = {}
                this.$forceUpdate()
                return
              }
              
              this.invoiceitems[this.selectedIdforEdit].discount_id=data.id
              this.invoiceitems[this.selectedIdforEdit].discount=data.price
              this.updateDiscount = data
              this.$forceUpdate()
              this.calculateUpdateAmount()
            },
            updateKapal(data){
              console.log(data.kapal_id.id)
              this.newInvoiceLain.vessel_id=data.kapal_id.id;
            },

            fetchVessels() {
              // Fetch data from the vessel API
              axios.get(this.$baseUrl + "/api/master/seeker/vessel", {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("accessToken"),
                },
              })
              .then((response) => {
                this.vessels = response.data; // Assuming the response is an array of vessels
              })
              .catch((error) => {
                // Handle error
              });
            },

            getVesselName(vesselId) {
              // Find the vessel name by ID
              const vessel = this.vessels.find(v => v.id === vesselId);
              return vessel ? vessel.name : '-'; // Return vessel name or '-' if not found
            },

          validateInvoiceId() {
            this.invoiceId = this.invoiceId.replace(/\D/g, '').slice(0, 6); 
              this.updateInvoiceNumber();
          },
          updateInvoiceNumber() {
            this.newInvoiceLain.invoice_no = this.formattedInvoiceNumber;
          },

        },
        mounted() {
        this.updateInvoiceNumber();
        
          
        },
    }
</script>
<style scoped>
.btn {
    padding:2px 6px;
}
/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
} */
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    width: 50%;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;

  
}
.invoice-input {
  display: flex;
  align-items: center; /* Vertikal tengah untuk prefix dan input */
}

.prefix {
  margin-right: 8px; /* Jarak antara prefix dan input */
  font-weight: bold; /* Mengubah tampilan prefix jika diperlukan */
}  
</style>